import React from "react";
import { useLocation } from "react-router-dom";
import "./Success.css";

const Success = () => {
  const { state } = useLocation();
  const orderDetails = state?.orderDetails || {};

  // Safely format tax_amount, handling string or number
  const formatTax = (tax) => {
    if (!tax) return "0.00";
    const taxNum = typeof tax === "string" ? parseFloat(tax) : tax;
    return isNaN(taxNum) ? "0.00" : taxNum.toFixed(2);
  };

  return (
    <div className="success-container">
      <h1>Payment Successful!</h1>
      <p>
        Thank you for your purchase. A receipt has been sent to{" "}
        {orderDetails.customer_email || "your email"}.
      </p>
      <h2>Order Summary</h2>
      <ul>
        {orderDetails.cart?.map((item, index) => (
          <li key={index}>
            {item.title} - Qty: {item.quantity} - $
            {(item.price * item.quantity).toFixed(2)}
          </li>
        ))}
      </ul>
      <p>Shipping: ${orderDetails.shipping_cost?.toFixed(2) || "0.00"}</p>
      <p>Tax: ${formatTax(orderDetails.tax_amount)}</p>
      <p>Total: ${orderDetails.total || "N/A"}</p>
      <p>Shipped to: {orderDetails.shipping_address || "N/A"}</p>
    </div>
  );
};

export default Success;
